import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type TeamId = string | number;

type CreateResendParams = {
  targetId: TeamId;
};

type ResendOptions = number[] | Record<string, any>;

function getTeamsHelper() {
  return clientApi.getOCClient().helpers.employer.teams;
}

function getInvitationsHelper(teamId: TeamId) {
  return getTeamsHelper().id(teamId).invitations;
}

const {
  useFind: useTeamInvitations,
  useCreate: useTeamInvitationsCreation,
  useDelete: useDeleteTeamInvitation,
} = getCRUDHooks({
  entityName: 'teamInvitation',
  find: ({ teamId, filters }) => getInvitationsHelper(teamId).find(filters),
  create: (newInvitation: any, { teamId }) => getInvitationsHelper(teamId).create(newInvitation),
  remove: ({
    targetId: teamId,
    options,
  }: {
    targetId: TeamId;
    options: TeamId[] | Record<string, any>;
  }) => getTeamsHelper().deleteInvitations(teamId, options),
});

const { useCreate: useResendTeamInvitation } = getCRUDHooks({
  entityName: 'resendTeamInvitation',
  create: (resendOptions: ResendOptions, { targetId: teamId }: CreateResendParams) =>
    getTeamsHelper().resendInvitations(teamId, resendOptions),
});

export {
  useTeamInvitations,
  useTeamInvitationsCreation,
  useResendTeamInvitation,
  useDeleteTeamInvitation,
};
